import React from "react";
import NftRewardsDashboard from "./NftRewardsDashboard";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Keep a copy so users can screenshot / paste it.
    this.setState({ info });
    // Also log to console for devtools.
    // eslint-disable-next-line no-console
    console.error("UI crashed:", error, info);
  }

  render() {
    if (this.state.hasError) {
      const msg = this.state.error ? String(this.state.error) : "Unknown error";
      const stack = this.state.error && this.state.error.stack ? this.state.error.stack : "";
      return (
        <div style={{ padding: 24, fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace" }}>
          <h2 style={{ margin: 0, marginBottom: 12 }}>Something went wrong</h2>
          <p style={{ marginTop: 0, opacity: 0.85 }}>
            The app loaded, but a rendering error occurred. Open the browser console (F12 → Console) and share the error text.
          </p>
          <div style={{ border: "1px solid #ddd", borderRadius: 12, padding: 12, background: "#fafafa" }}>
            <div style={{ marginBottom: 8, fontWeight: 700 }}>Error</div>
            <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>{msg}</pre>
            {stack ? (
              <>
                <div style={{ marginTop: 12, marginBottom: 8, fontWeight: 700 }}>Stack</div>
                <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>{stack}</pre>
              </>
            ) : null}
          </div>
        </div>
      );
    }

    return <NftRewardsDashboard />;
  }
}

export default function App() {
  return <ErrorBoundary />;
}
